/* Wuffy Lab - Feeding calculator (Wuffes-style) */
(function () {
  'use strict';
  var DISCOUNTS = [10, 12.5, 15];
  var LOADING_MS = 1600;

  function parse(el, fb) { try { return JSON.parse(el.textContent); } catch (e) { return fb; } }
  function tpl(str, map) { return String(str || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] !== undefined ? map[k] : m; }); }
  function pct(n) { var r = Math.round(n * 10) / 10; return String(r).replace('.', ',') + ' %'; }

  function init(root) {
    if (root.__wlFc) return; root.__wlFc = true;
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return [].slice.call(root.querySelectorAll(s)); };

    var tiers = parse(q('[data-wl-fc-tiers]'), []);
    var variants = parse(q('[data-wl-fc-variants]'), []);
    var L = parse(q('[data-wl-fc-labels]'), {});
    var perPot = Number(root.getAttribute('data-wl-fc-per-pot')) || 120;
    var max = Number(root.getAttribute('data-wl-fc-max')) || 70;
    var hasPlans = variants.some(function (v) { return v.sp && v.sp.length; });
    var mode = (root.getAttribute('data-wl-fc-mode') === 'sub' && hasPlans) ? 'sub' : 'once';
    var afterAdd = root.getAttribute('data-wl-fc-cart') || 'drawer';

    var fmt;
    try { var nf = new Intl.NumberFormat(L.locale || 'fr', { style: 'currency', currency: L.currency || 'EUR' }); fmt = function (c) { return nf.format(c / 100); }; }
    catch (e) { fmt = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }; }

    var states = { input: q('[data-wl-fc-state="input"]'), loading: q('[data-wl-fc-state="loading"]'), result: q('[data-wl-fc-state="result"]') };
    var show = function (name) { Object.keys(states).forEach(function (k) { if (states[k]) states[k].hidden = k !== name; }); };

    var range = q('[data-wl-fc-range]'), num = q('[data-wl-fc-num]'), prog = q('[data-wl-fc-progress]');
    var dogs = qa('[data-wl-fc-dog]');
    var clamp = function (v) { v = Math.round(Number(v)); if (isNaN(v)) v = 0; return Math.max(0, Math.min(max, v)); };
    var weight = clamp(range ? range.value : root.getAttribute('data-wl-fc-default'));

    var paintSlider = function () {
      var p = (weight / max) * 100;
      if (range && Number(range.value) !== weight) range.value = weight;
      if (num && document.activeElement !== num) num.value = weight;
      if (prog) prog.style.width = p + '%';
      root.style.setProperty('--wl-fc-p', p + '%');
      dogs.forEach(function (d) {
        var on = weight >= Number(d.getAttribute('data-wl-fc-dog-kg') || 0);
        if (on && !d.classList.contains('is-active')) { d.classList.add('is-active'); d.classList.remove('is-bounce'); void d.offsetWidth; d.classList.add('is-bounce'); }
        else if (!on) { d.classList.remove('is-active', 'is-bounce'); }
      });
    };
    if (range) range.addEventListener('input', function () { weight = clamp(range.value); paintSlider(); });
    if (num) {
      num.addEventListener('input', function () { if (num.value === '') return; weight = clamp(num.value); paintSlider(); });
      num.addEventListener('blur', function () { num.value = weight; });
      num.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); num.blur(); calculate(); } });
    }
    dogs.forEach(function (d, i) { d.style.left = (dogs.length > 1 ? i / (dogs.length - 1) * 100 : 0) + '%'; });
    paintSlider();

    var tierFor = function (kg) {
      for (var i = 0; i < tiers.length; i++) { var t = tiers[i]; if (!t.max || t.max <= 0 || kg <= t.max) return t; }
      return tiers[tiers.length - 1] || { chews: 1, label: '', size: '' };
    };
    var sizeValues = [], fmtValues = [];
    variants.forEach(function (v) { if (sizeValues.indexOf(v.o[0]) < 0) sizeValues.push(v.o[0]); if (v.o[1] !== undefined && fmtValues.indexOf(v.o[1]) < 0) fmtValues.push(v.o[1]); });
    var norm = function (s) { return String(s || '').toLowerCase().replace(/\s+/g, ''); };
    var sizeValueFor = function (tier, idx) {
      var want = norm(tier.size);
      for (var i = 0; i < sizeValues.length; i++) { if (norm(sizeValues[i]) === want) return sizeValues[i]; }
      return sizeValues[Math.min(idx, sizeValues.length - 1)] || null;
    };
    var potsFor = function (fmtValue, idx) { var m = /(\d+)/.exec(fmtValue || ''); return m ? Number(m[1]) : idx + 1; };
    var findVariant = function (size, f) {
      for (var i = 0; i < variants.length; i++) { var v = variants[i]; if ((size === null || v.o[0] === size) && (f === undefined || v.o[1] === f)) return v; }
      return null;
    };
    var planMeta = function (p) {
      var s = (p.n || '') + ' ' + (p.o || '');
      var w = /(\d+)\s*(week|semaine)/i.exec(s), d = /(\d+(?:[.,]\d+)?)\s*%/.exec(s);
      return { weeks: w ? Number(w[1]) : 0, pct: d ? Number(d[1].replace(',', '.')) : 0 };
    };
    var planFor = function (v, pots, days) {
      if (mode !== 'sub' || !v.sp || !v.sp.length) return null;
      var weeks = Math.max(1, Math.round(days / 7)), want = DISCOUNTS[Math.min(pots, DISCOUNTS.length) - 1];
      var best = null, bs = Infinity;
      v.sp.forEach(function (p) { var m = planMeta(p); var sc = Math.abs(m.weeks - weeks) + (Math.abs(m.pct - want) < 0.01 ? 0 : 1000); if (sc < bs) { bs = sc; best = p; } });
      return best;
    };

    var current = null;
    var compute = function () {
      var t = tierFor(weight), tIdx = tiers.indexOf(t);
      var size = sizeValueFor(t, tIdx);
      var chews = Number(t.chews) || 1;
      var daysPerPot = Math.max(1, Math.floor(perPot / chews));
      var opts = (fmtValues.length ? fmtValues : [null]).map(function (f, i) {
        var v = findVariant(size, f === null ? undefined : f);
        if (!v) return null;
        var pots = f === null ? 1 : potsFor(f, i);
        var days = daysPerPot * pots;
        var plan = planFor(v, pots, days);
        var pc = plan ? plan.pc : v.pc;
        var one = findVariant(size, fmtValues[0]);
        var base = one ? one.pc * pots : v.pc;
        var save = plan ? planMeta(plan).pct : (base > pc ? (1 - pc / base) * 100 : 0);
        return { f: f, v: v, pots: pots, days: days, plan: plan, pc: pc, cc: v.cc, oncePc: v.pc, perDay: Math.round(pc / days), oncePerDay: Math.round(v.pc / days), save: save };
      }).filter(Boolean);
      current = { tier: t, size: size, chews: chews, daysPerPot: daysPerPot, options: opts, sel: Math.min(1, opts.length - 1) };
      if (opts.length === 1) current.sel = 0;
    };

    var icons = q('[data-wl-fc-icons]'), chewTpl = q('[data-wl-fc-chew-tpl]');
    var amount = q('[data-wl-fc-amount]'), sizeLabel = q('[data-wl-fc-size-label]');
    var optsBox = q('[data-wl-fc-options]');
    var addBtn = q('[data-wl-fc-add]'), addPrice = q('[data-wl-fc-add-price]'), addOld = q('[data-wl-fc-add-old]');
    var toggle = q('[data-wl-fc-toggle]'), err = q('[data-wl-fc-error]');

    var paintResult = function () {
      var c = current; if (!c) return;
      if (icons) {
        icons.innerHTML = '';
        for (var i = 0; i < Math.min(c.chews, 6); i++) { if (chewTpl) icons.appendChild(chewTpl.content.cloneNode(true)); }
      }
      if (amount) amount.textContent = tpl(c.chews > 1 ? L.chew_plural : L.chew_singular, { n: c.chews });
      if (sizeLabel) { sizeLabel.textContent = (L.size_prefix ? L.size_prefix + ' ' : '') + (c.tier.label || ''); sizeLabel.hidden = !c.tier.label; }

      if (optsBox) {
        optsBox.innerHTML = '';
        c.options.forEach(function (o, i) {
          var lab = document.createElement('label');
          lab.className = 'wl-fc__opt' + (i === c.sel ? ' is-on' : '');
          var isRec = i === 1 || c.options.length === 1;
          lab.innerHTML =
            '<input type="radio" class="wl-fc__opt-radio" name="wl-fc-' + root.getAttribute('data-wl-fc-id') + '" value="' + i + '"' + (i === c.sel ? ' checked' : '') + '>' +
            (isRec && L.recommended ? '<span class="wl-fc__opt-badge">' + L.recommended + '</span>' : '') +
            '<span class="wl-fc__opt-body">' +
              '<span class="wl-fc__opt-title">' + tpl(L.opt_title, { days: o.days, format: o.f || '', pots: o.pots }) + '</span>' +
              '<span class="wl-fc__opt-sub">' + (o.plan ? tpl(L.opt_sub, { days: o.days, weeks: Math.round(o.days / 7) }) : tpl(L.opt_once, { format: o.f || '', days: o.days })) + '</span>' +
              (o.save > 0.05 ? '<span class="wl-fc__opt-save">' + tpl(L.opt_save, { pct: pct(o.save) }) + '</span>' : '') +
            '</span>' +
            '<span class="wl-fc__opt-price">' +
              '<span class="wl-fc__opt-day">' + fmt(o.perDay) + (L.per_day || '/jour') + '</span>' +
              (o.plan && o.oncePc > o.pc ? '<span class="wl-fc__opt-day-old">' + fmt(o.oncePerDay) + '</span>' : (o.cc > o.pc ? '<span class="wl-fc__opt-day-old">' + fmt(Math.round(o.cc / o.days)) + '</span>' : '')) +
            '</span>';
          lab.querySelector('input').addEventListener('change', function () { c.sel = i; paintResult(); });
          optsBox.appendChild(lab);
        });
      }
      var o = c.options[c.sel];
      if (addBtn && o) {
        addBtn.disabled = !o.v.a; addBtn.classList.toggle('is-off', !o.v.a);
        if (addPrice) addPrice.textContent = fmt(o.pc);
        if (addOld) { if (o.cc > o.pc) { addOld.textContent = fmt(o.cc); addOld.hidden = false; } else { addOld.hidden = true; } }
      }
      if (toggle) {
        if (!hasPlans || !o) { toggle.hidden = true; }
        else { toggle.hidden = false; toggle.textContent = mode === 'sub' ? tpl(L.once_link, { price: fmt(o.oncePc) }) : tpl(L.sub_link, { save: pct(DISCOUNTS[DISCOUNTS.length - 1]) }); }
      }
      if (err) err.hidden = true;
    };
    if (toggle) toggle.addEventListener('click', function () { mode = mode === 'sub' ? 'once' : 'sub'; var sel = current ? current.sel : 1; compute(); current.sel = sel; paintResult(); });

    var calculate = function () {
      compute();
      show('loading');
      var vid = states.loading && states.loading.querySelector('video');
      if (vid) { try { vid.currentTime = 0; vid.play(); } catch (e) {} }
      setTimeout(function () { paintResult(); show('result'); try { states.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {} }, LOADING_MS);
      try {
        var f = document.querySelector('[data-wl-product-form]');
        if (f && current && current.size) { var inp = f.querySelector('[data-wl-opt="0"] input[value="' + current.size.replace(/"/g, '\\"') + '"]'); if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); } }
      } catch (e) {}
    };
    var calcBtn = q('[data-wl-fc-calc]'); if (calcBtn) calcBtn.addEventListener('click', calculate);
    var restart = q('[data-wl-fc-restart]'); if (restart) restart.addEventListener('click', function () { show('input'); try { states.input.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {} });

    if (addBtn) addBtn.addEventListener('click', function () {
      var o = current && current.options[current.sel]; if (!o) return;
      addBtn.classList.add('is-busy'); addBtn.disabled = true;
      var body = { items: [{ id: o.v.id, quantity: 1 }], sections: 'cart-drawer-section' };
      if (o.plan) body.items[0].selling_plan = o.plan.id;
      fetch((L.add_url || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function (json) {
          addBtn.classList.remove('is-busy'); addBtn.disabled = false;
          var drawer = document.getElementById('cart-drawer');
          if (afterAdd === 'drawer' && drawer && typeof drawer.showDialog === 'function') {
            try {
              document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: json, sourceId: root.getAttribute('data-wl-fc-id'), data: { source: 'product-form-component', itemCount: (json && json.items ? json.items.length : 1), sections: json.sections || {}, productId: String(json.product_id || '') } } }));
              drawer.showDialog();
              return;
            } catch (e) {}
          }
          window.location.href = L.cart_url || '/cart';
        })
        .catch(function () { addBtn.classList.remove('is-busy'); addBtn.disabled = false; if (err) { err.textContent = L.error || 'Erreur'; err.hidden = false; } });
    });
  }

  function boot() { [].slice.call(document.querySelectorAll('[data-wl-fc]')).forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector('[data-wl-fc]'); if (r) init(r); });
})();
